module.exports = __webpack_public_path__ + "media/images/plan-grid3@2x-39fe5f224aae68de50da79fb1e39e5ed.jpg";